import * as User from "./user"

const MailItem = [
    {
        uuid: "bb428c03-1bc6-4f3d-9d5e-268ec44eebc3",
        type: "trashed",
        tag: "Promotion",
        title: "This email is a test",
        created_at: "2018-04-10T23:10:41.266Z",
        content:
            "This email is a test. Veniam et qui quia ut necessitatibus architecto ad. Vel ut consequatur non sint est error sint.\n \rError asperiores a esse ad. Rerum eum magni aperiam voluptas excepturi. Suscipit est modi magni et ut eum ut.\n \rCumque eius voluptatem sit qui nisi. Eos eum est cumque est ipsa odit earum voluptas. Dolorum ipsam rerum ut.\n \rAutem quia delectus quia rerum deleniti reprehenderit voluptatibus quisquam. Necessitatibus molestias vel odio neque expedita nulla libero voluptatem numquam. In labore modi. Unde molestiae id molestias vero delectus rerum nesciunt voluptatum exercitationem.\n \rCorrupti et voluptatibus ea dolorem laboriosam. Amet cupiditate beatae nulla. Facilis sit est. Sed ducimus ducimus alias rem nam.",
        fromId: "14ddae1e-986d-42f4-8d17-46a02d469b2b",
        attachments: []
    },
    {
        uuid: "a19bf9fc-e877-49e7-a75a-b089a2c35f18",
        type: "draft",
        tag: "Social",
        title: "Ipsum maiores ab amet voluptas enim.",
        created_at: "2018-04-10T12:05:32.328Z",
        content:
            "Dolores corporis quam perferendis consequatur autem minus recusandae non. Id corrupti qui et. Sed a accusamus veritatis earum et consequatur mollitia. Iure consequatur omnis aspernatur itaque laboriosam aut ut. Enim repellendus sed similique minima voluptatem sed ea. Exercitationem aut est eius rerum.\n \rUt veniam quidem et numquam reprehenderit aliquam. Omnis eos qui enim hic modi maiores. Nisi itaque et unde ullam laborum ut aut facilis. Enim qui aut est.\n \rTotam molestiae velit aperiam rerum. Voluptatum quo ab. Quae cupiditate sit quia illum delectus nobis adipisci sunt.\n \rAlias nostrum ad ipsam aut nulla et repudiandae incidunt doloribus. Vero rerum omnis. Consequatur eius et accusamus quaerat et unde animi. Sed et quaerat sit quis mollitia. Accusantium voluptatem perferendis qui enim similique molestiae ut sit velit.\n \rProvident quibusdam excepturi asperiores vitae earum ut fugiat. Eligendi illum nisi dolor. Maiores velit vitae minus.",
        fromId: "60d07662-bfec-42c7-b044-c81bc4ff8c7a",
        attachments: []
    },
    {
        uuid: "910d7e0a-f3b0-47a7-bb53-9036ed717298",
        type: "starred",
        tag: "Work",
        title: "Quo consequatur cumque.",
        created_at: "2018-04-11T02:12:00.447Z",
        content:
            "Accusamus enim nihil aliquam soluta praesentium repudiandae autem voluptatum. Dolore aut at incidunt molestias commodi odit et. Quis possimus et dolorem. Cupiditate nulla voluptas. Quis sit ab.\n \rIusto accusamus neque commodi est omnis et aut doloremque autem. Illo unde est deserunt accusantium. Quia iusto velit autem dignissimos natus sit voluptatum. Aliquam et quibusdam mollitia consectetur quod aut at eveniet consequatur.\n \rMagnam et repellat tenetur libero. Quasi autem animi exercitationem est enim dolores facere earum fugit. Porro necessitatibus est amet quis. Officia qui itaque inventore magnam ut temporibus ad.\n \rOfficia ratione velit vel consequatur et est. Quibusdam consequatur et earum et ut consequatur dolorem at minus. Sit aperiam voluptas dolorem id. Et ad deleniti sunt consequatur omnis commodi distinctio dolor. Asperiores eum similique est aut. Totam harum voluptates ipsum dolores eos dolor ut.\n \rNam qui sed. Maiores occaecati voluptatibus iste quae temporibus odit. Voluptas vel quis suscipit ex ab. Dolores aut explicabo modi rerum et odit similique. Ut officia corrupti rerum repellendus laborum. Velit in aliquam ex blanditiis et ab.",
        fromId: "77f4b102-9df5-43ba-966a-6f816806c5e2",
        attachments: []
    },
    {
        uuid: "c79cb60a-baf8-4349-b9c3-88d567b965a2",
        type: "draft",
        tag: "Social",
        title: "Qui consequatur et rerum optio atque.",
        created_at: "2018-04-10T18:56:23.358Z",
        content:
            "Explicabo quidem a dolore modi nihil id nostrum voluptates ex. Repellendus quis tempore unde molestiae unde ipsa. Excepturi quod omnis facere est porro incidunt ratione suscipit.\n \rCupiditate et sunt iure aperiam. Beatae cupiditate cumque. Dolorem iste quia unde cum est molestiae est.\n \rMolestiae et sit dolore iste ipsam voluptas quia. Ut quia unde culpa ipsa commodi possimus. Ut maiores molestiae sunt qui labore. Provident sit eius recusandae numquam eum exercitationem quis asperiores.\n \rEaque et at ea voluptatem id qui omnis. Aut ex rem. Iste voluptate magni sequi eaque sit numquam accusantium aut molestias.\n \rSit laboriosam magni illum accusantium aut nulla corporis sed. Et ratione iusto dolor porro voluptatem voluptatem voluptate. Autem non animi. Aut unde aliquid omnis natus suscipit. Saepe dicta veritatis id autem doloremque tempore corrupti.",
        fromId: "7d910620-84e1-49fc-951e-d375587b8189",
        attachments: []
    },
    {
        uuid: "35bddac1-1046-4c96-a1ac-ffd75def7f5a",
        type: "trashed",
        tag: "Social",
        title: "Reiciendis sunt aliquid.",
        created_at: "2018-04-10T19:58:14.408Z",
        content:
            "Qui facere quia est consequatur nihil dolores dolorem magni eum. Occaecati ab atque ut vitae ipsum officiis et expedita. Quisquam architecto repellat eos. Ut repellendus animi rerum delectus natus. Explicabo est enim est fugiat nisi est alias non.\n \rMaxime autem eum ut est et dolorem. Non ab deserunt voluptatem sequi deleniti quo commodi. Est tempore rerum quia. Id est temporibus iste voluptas amet omnis amet. Veniam blanditiis consequuntur laborum.\n \rVoluptates nihil ut. Doloremque dicta at consequuntur qui. Sit culpa possimus aut nemo. Aut atque quaerat voluptatum nostrum voluptatum laudantium officia quia incidunt. Quia est earum aut.\n \rQuisquam dolorum dolorum. Dicta quas veniam dignissimos fugiat. Ut nostrum dolores explicabo eos rem dolores dolorum autem. A dolorem eum reiciendis amet ea et.\n \rSit tempore ut. Culpa veniam voluptatum quod odio. Cum fugit autem doloremque quidem molestias labore.",
        fromId: "46d6f992-5729-4588-b7f8-ce74f21157ba",
        attachments: []
    },
    {
        uuid: "0c914dfd-be0d-4d46-b963-47bcb064154f",
        type: "sent",
        tag: "Work",
        title: "Libero odit voluptate dolorem error cupiditate in.",
        created_at: "2018-04-11T04:07:16.152Z",
        content:
            "Delectus nisi enim ut illum magni quasi. Voluptatem consequatur quia quis. Consectetur dolores molestiae debitis aut voluptatem recusandae sit. Ut voluptas expedita aut et possimus sint.\n \rAmet cumque corporis ipsam non iure autem. Aut molestiae est. Est itaque doloremque consequuntur nesciunt et error quibusdam.\n \rEos architecto dignissimos voluptatem ut voluptate quisquam. Fugiat provident iste perspiciatis provident accusamus rerum. Tempora et ducimus velit eaque ratione eum. Voluptas tempore ullam. Et cum eos dolor nesciunt perferendis est.\n \rPerferendis aperiam id adipisci ea distinctio totam ut fugit eaque. Qui harum autem et vero vero sit. Ex pariatur hic deleniti.\n \rVoluptatem tenetur dolorem omnis dolorem vel ratione vel dolores necessitatibus. Eius culpa harum excepturi. Corrupti ut aut. Vitae quia ut necessitatibus aliquam et. Libero mollitia sit et dicta.",
        fromId: "65a6eb21-67b5-45c3-9af7-faca2d9b60d4",
        attachments: []
    },


]

// add user to mail
MailItem.map(item => {
    let users = User.getUser()
    item.from = users.find(x => x.uuid === item.fromId)
    return item
})
//
var sentlength = MailItem.filter(item => item.type === 'sent').length;

const MailMenu = [
    {
        title: "Inbox",
        group: "email",
        icon: "mdi-email",
        to: { path: "/email/inbox" },
        chip: MailItem.length
    },
    {
        title: "Sent",
        group: "email",
        icon: "mdi-send",
        to: { path: "/email/sent" },
        chip: sentlength
    },
    {
        title: "Starred",
        group: "email",
        icon: "mdi-star",
        to: { path: "/email/starred" },

    },
    {
        title: "Draft",
        group: "email",
        icon: "mdi-email",
        to: { path: "/email/draft" },

    },
    {
        title: "Trash",
        group: "email",
        icon: "mdi-delete",
        to: { path: "/email/trashed" },

    },
    { heading: "CATEGORY" },
    {
        icon: "mdi-checkbox-blank-circle",
        iconColor: "warning",
        group: "email",
        title: "Work",
        to: { path: "/email/0/Work" },
        iconSize: "small",

    },
    {
        icon: "mdi-checkbox-blank-circle",
        iconColor: "success",
        title: "Promotional",
        to: { path: "/email/0/Promotion" },
        iconSize: "small"
    },
    {
        icon: "mdi-checkbox-blank-circle",
        iconColor: "error",
        title: "Personal",
        to: { path: "/email/0/Personal" },
        iconSize: "small"
    },
    {
        icon: "mdi-checkbox-blank-circle",
        iconColor: "primary",
        title: "Social",
        to: { path: "/email/0/Social" },
        iconSize: "small"
    }
]

const getMail = limit => {
    return limit ? MailItem.slice(0, limit) : MailItem
}

const getMailById = uuid => {
    return uuid === undefined ? MailItem[0] : MailItem.find(x => x.uuid === uuid)
}

const getMailByType = type => {
    return type === "inbox" ? MailItem : MailItem.filter(x => x.type === type)
}
const getMailByTag = tag => {
    return tag ===  undefined ? MailItem : MailItem.filter(x => x.tag === tag)
}
export { getMail, MailMenu, getMailById, getMailByType, getMailByTag }
